import { add } from 'date-fns';
import ModalConfirmationScreenContent from 'shared/components/ModalConfirmationScreen/ModalConfirmationScreenContent';
import { useDate } from 'shared/hooks';
import { useTranslation } from 'react-i18next';
import useSelectOrderDateModalV2 from '../../hooks/useSelectOrderDateModalV2';

type SelectDateSuccessV2Props = {
  ctaOnClick?: () => void;
};

const SelectDateSuccessV2 = ({ ctaOnClick }: SelectDateSuccessV2Props) => {
  const { t } = useTranslation('modalWindows');

  const { info } = useSelectOrderDateModalV2();

  const { formattedDateString } = useDate({
    date: info?.date,
    dateFormat: 'MMMM d, yyyy'
  });
  const { formattedDateString: formattedFutureDateString } = useDate({
    date: info?.date,
    dateFormat: 'MMMM d, yyyy',
    processDate: (date) => add(date, info?.duration!)
  });

  return (
    <ModalConfirmationScreenContent
      title={t('changeOrderDate.title')}
      ctaOnClick={ctaOnClick}
      subtitle={t('changeOrderDate.newDateSuccessText', { date: formattedDateString })}
      description={t('changeOrderDate.nextOrderDateSuccessText', {
        date: formattedFutureDateString
      })}
    />
  );
};

export default SelectDateSuccessV2;
